export default {
  'HC': {
    'title': 'high-confidence',
    'color': 'black',
    'desc': 'Variants which pass all LOFTEE filters' 
  },
  'LC': {
    'title': 'low-confidence',
    'color': 'black',
    'desc': 'Variants which fail at least one LOFTEE filter'
  },
}
